import React from "react";
import { View, StyleSheet, Text } from "react-native";
import { ButtonVariant } from "../../../components/CustomButton";
import { usePlatform } from "../../../providers/PlatformProvider";
import CustomLinearGradient, { GRADIENT_TYPE } from "../../../components/CustomLinearGradient";
import { CardData } from "../helpers/renderContent";
import { TrackedButton, TrackedTouchable } from "../../../analytics/components";
import { useThemeSettings } from "../../../ThemeProvider";
import getGlobalStyles from "../../../globalStyles";
import TourStep from "../../../components/productTours/TourStep";
import { TOUR_TYPES } from "../../../store/useTourStore";

interface Props {
  tabs: CardData[];
  setActiveTab: (cardKey: string) => void;
  activetab: string
}

export const TabsHeader: React.FC<Props> = ({
  tabs,
  setActiveTab,
  activetab
}) => {
  const { showWebVersion } = usePlatform();
  const { theme } = useThemeSettings();
  const gStyle = getGlobalStyles(theme);

  return (

    <View style={[gStyle.centerRow, { justifyContent: 'space-around', gap: showWebVersion ? 30 : 0, paddingVertical: 10 }]}>
      {tabs.map((tab, index) => (
        showWebVersion ?
          <TrackedButton id={tab.key} context={{ cta: 'CHANGE_VIEW', active_view: activetab, change_to: tab.key }} variant={activetab === tab.key ? ButtonVariant.NORMAL_PRIMARY : ButtonVariant.NORMAL} style={{ paddingHorizontal: 30 }} labelStyle={{ lineHeight: 20 }}
            key={`${tab.key}tab`} onPress={() => setActiveTab(tab.key)}>
            {tab.title}
          </TrackedButton> :
          // order rearrange to show gist first
          <TourStep order={(index === 0 ? 1 : index === 1 ? 0 : index) + 1} key={`${tab.key}tab`} type={TOUR_TYPES.NEWS_DETAILS}>
            <TrackedTouchable context={{ cta: 'CHANGE_VIEW', active_view: activetab, change_to: tab.key }}
              id={tab.key} onPress={() => setActiveTab(tab.key)}>
              <Text style={[styles.tabText, activetab === tab.key ? styles.active : {}, { color: theme?.colors?.textPrimary }]}>{tab.title}</Text>
              {activetab === tab.key && <CustomLinearGradient gradientType={GRADIENT_TYPE.UNDERLINE} />}
            </TrackedTouchable>
          </TourStep>
      ))}</View>
  );
}
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: 80,
    alignItems: 'center',
    maxWidth: 1000,
    paddingHorizontal: 16
  },
  active: {
    fontWeight: 600
  },
  tabText: {
    color: '#221201',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 18
  }
});
